// import React, { createContext, useContext, useState, useEffect } from "react";
// import axios from "axios";

// const AuthContext = createContext(null);

// function applyToken(token) {
//   if (token) {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   } else {
//     delete axios.defaults.headers.common["Authorization"];
//   }
// }

// export function AuthProvider({ children }) {
//   const [user, setUser]       = useState(null);
//   const [loading, setLoading] = useState(true);

//   const consumeBypassToken = () => {
//     if (!window.location.hash.includes("token=")) return false;
//     const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
//     const token    = params.get("token");
//     const username = params.get("username");
//     const role     = params.get("role");
//     if (!token || !username) return false;

//     applyToken(token);
//     localStorage.setItem("token", token);
//     localStorage.setItem("user", JSON.stringify({ username, role }));

//     const clean = window.location.pathname + window.location.search;
//     window.history.replaceState(null, "", clean);
//     return true;
//   };

//   useEffect(() => {
//     const cameFromBypass = consumeBypassToken();

//     const token  = localStorage.getItem("token");
//     const stored = localStorage.getItem("user");
//     if (token && stored) {
//       try {
//         applyToken(token);
//         const parsed = JSON.parse(stored);
//         setUser(parsed);
//         axios.get("/api/auth/me").then(res => {
//           const fresh = { ...parsed, permissions: res.data.permissions ?? [] };
//           setUser(fresh);
//           localStorage.setItem("user", JSON.stringify(fresh));
//         }).catch(() => {
//           if (cameFromBypass) {
//             localStorage.removeItem("token");
//             localStorage.removeItem("user");
//             setUser(null);
//           }
//         });
//       } catch {
//         localStorage.removeItem("token");
//         localStorage.removeItem("user");
//       }
//     }
//     setLoading(false);
//   }, []);

//   const login = async (username, password) => {
//     const res = await axios.post("/api/auth/login", { username, password });
//     const { token, role, uid } = res.data;
//     applyToken(token);
//     const meRes = await axios.get("/api/auth/me");
//     const userData = { username, role, uid, permissions: meRes.data.permissions ?? [] };
//     localStorage.setItem("token", token);
//     localStorage.setItem("user", JSON.stringify(userData));
//     setUser(userData);
//     return res.data;
//   };

//   const logout = async () => {
//     try { await axios.post("/api/auth/logout"); } catch (_) {}
//     applyToken(null);
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     setUser(null);
//   };

//   const refreshPermissions = async () => {
//     try {
//       const res = await axios.get("/api/auth/me");
//       setUser(prev => {
//         const updated = { ...prev, permissions: res.data.permissions ?? [] };
//         localStorage.setItem("user", JSON.stringify(updated));
//         return updated;
//       });
//     } catch (_) {}
//   };

//   const hasPermission = (perm) => {
//     if (!user) return false;
//     if (user.role === "admin") return true;
//     return (user.permissions || []).includes(perm);
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout, loading, hasPermission, refreshPermissions }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export const useAuth = () => useContext(AuthContext);






import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

function applyToken(token) {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
}

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  const consumeBypassToken = () => {
    if (!window.location.hash.includes("token=")) return false;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    // const token    = params.get("token");
    // const username = params.get("username");
    // const role     = params.get("role");
    // if (!token || !username) return false;

    // applyToken(token);
    // localStorage.setItem("token", token);
    // localStorage.setItem("user", JSON.stringify({ username, role, viaBypass: true }));


    const token          = params.get("token");
    const username       = params.get("username");
    const role           = params.get("role");
    const vendorName     = params.get("vendorName");
    const deliveryNoteId = params.get("deliveryNoteId");
    if (!token || !username) return false;

    applyToken(token);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify({
      username, role, viaBypass: true, vendorName, deliveryNoteId,
    }));

    const clean = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", clean);
    return true;
  };

  useEffect(() => {
    const cameFromBypass = consumeBypassToken();

    const token  = localStorage.getItem("token");
    const stored = localStorage.getItem("user");
    if (token && stored) {
      try {
        applyToken(token);
        const parsed = JSON.parse(stored);
        setUser(parsed);
        axios.get("/api/auth/me").then(res => {
          const fresh = { ...parsed, permissions: res.data.permissions ?? [] };
          setUser(fresh);
          localStorage.setItem("user", JSON.stringify(fresh));
        }).catch(() => {
          if (cameFromBypass) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            setUser(null);
          }
        });
      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const res = await axios.post("/api/auth/login", { username, password });
    const { token, role, uid } = res.data;
    applyToken(token);
    const meRes = await axios.get("/api/auth/me");
    const userData = { username, role, uid, permissions: meRes.data.permissions ?? [] };
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
    return res.data;
  };

  const logout = async () => {
    try { await axios.post("/api/auth/logout"); } catch (_) {}
    applyToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  const refreshPermissions = async () => {
    try {
      const res = await axios.get("/api/auth/me");
      setUser(prev => {
        const updated = { ...prev, permissions: res.data.permissions ?? [] };
        localStorage.setItem("user", JSON.stringify(updated));
        return updated;
      });
    } catch (_) {}
  };

  const hasPermission = (perm) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    return (user.permissions || []).includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, hasPermission, refreshPermissions }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);